<template>
  <div class="my_test_paper" ref="wrapRef">
    <div class="date">
        <a-date-picker size="large"   :getPopupContainer="() => wrapRef" v-model:value="start_time"  @change="handlePanelChange" picker="month" />
    <a-date-picker size="large"   :getPopupContainer="() => wrapRef" v-model:value="end_time" @change="handlePanelChange1" picker="month" />
    </div>
 
    <CommonTopSearch ref="CommonTopSearchRef"
    :undertone="true"
                     @initData="getPaperList" />
                     
    <!-- :style="{'margin-right':(index+1) % 4 == 0 ? '0' : '12px'}" -->
     <!-- <div class="title"><div style="margin-right: 8rem;"><img src="@/static/WarningCircle.png"></div><div>使用说明：平时成绩在及格线以下（含刚及格）建议训练基础版试卷，在及格线以上建议训练进阶版试卷！</div></div> -->
    <div class="papers" v-if="paperList.length > 0">
      <div class="paper"
           v-for="(item,index) in paperList"
           :key="index">
        <div class="warp">
          <div class="teacher_name">
            出卷教师:{{item.edu_user_name}}
          </div>
          <div class="content">
            <div class="content_txt">{{item.paper_name}}</div>

            <div class="score">
              总分:{{item.paper_score}}
            </div>
          </div>
        </div>
        <div class="btn_warp"
             @click="toPaperInfo(item)">
          <div> 开始做卷</div>
          <!--  <img src="@/static/teacher_paper/start.png"
               alt=""> -->
        </div>
        <div class="time">
          {{item.create_time}}
        </div>
      </div>
    </div>
    <div v-else
         class="its"
         > 暂无数据</div>
  </div>
</template>

<script setup>
import CommonTopSearch from '@/views/components/COMMON_TOP_SEARCH/index.vue'
import { getTeacherPaperList } from '@/api/teacherPaper.js'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs';
 
let router = useRouter()
let paperList = ref([])
let start_time = ref(null)
let end_time = ref(null)
const wrapRef = ref(null) 
let subject_id = ref(null)

const toPaperInfo = (row) => {
  let form = {
    edu_paper_id: row.edu_paper_id,
  }
  window.sessionStorage.removeItem('testpaperCardIndex')
  window.sessionStorage.removeItem('paper')
  window.sessionStorage.removeItem('images')
  router.push('doPaper?isTeacherPaper=1&form=' + JSON.stringify(form))
}
const handlePanelChange = (val, mode) => {
  console.log('mode',mode,val)
  //  start_time.value = mode
  
   getPaperList( subject_id.value ,"" )
}
   const handlePanelChange1 = (val, mode) => {
 
    // end_time.value = dayjs(mode, 'YYYY-MM');
   getPaperList( subject_id.value ,"" )
    };
const getPaperList = async (id, keywords) => {
  subject_id.value = id
  let params = {
    subject_id: id,
    keyword: keywords,
    subject_consultation:1,
    start_time:start_time.value?start_time.value.format('YYYY-MM'):'',
    end_time:end_time.value?end_time.value.format('YYYY-MM'):''
  }
  const { data } = await getTeacherPaperList(params)
  paperList.value = data.list
}

</script>

<style lang="scss"  scoped>
.my_test_paper {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  background-image: url("../../static/allBackg/学科问诊.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .date{
        display: flex;
  
    gap: 30rem;
    position: absolute;
    right: 30rem;
    top: 56rem;
  }
}
::v-deep 
  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
  border-radius: 4px;
background: var(--Brand-Color_1, #E3F2FD);
color: var(--Brand-Color_6default, #2196F3);

}
.ant-picker{
  border-radius: 120px;
}
::v-deep .subjectabs{
margin-top: 40rem;
}
.title{
  left: 446rem;
  top:83rem;
  position:absolute;
  color: var(--dark-100-ffffff, #FFF);
align-items: center;
font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 24rem; /* 150% */
display: flex;
}
.its {
  overflow: hidden;
  color: var(--light-ffffff, #fff);
  text-overflow: ellipsis;
  font-size: 28rem;
  font-style: normal;
  font-weight: 400;
  margin-left:900rem;
margin-top: 250rem;
  line-height: 42px; /* 150% */
}
.papers {
  display: flex;
  flex-wrap: wrap;
  // background-color: #1955e3;
  // border-radius: 25px;
  width: 100%;
  margin: 40rem 80rem;
  overflow-y: scroll;
  height: calc(100vh - 280rem);
  .paper {
    position: relative;
    width: 410rem;
    height: 380rem;
    background-image: url("../../static/teacher_paper/bg-教师试卷.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 30rem;
    margin-right: 40rem;
    overflow: hidden;
    .warp {
      box-shadow: 0px 1px 4px 0px rgba(230, 170, 86, 1);
      border-radius: 30rem;
      background: #ffffff;
      width: 350rem;
      height: 190rem;
      margin: 76rem auto 0;
      overflow: hidden;
      .teacher_name {
        height: 50rem;
        width: 350rem;
        background: #efa845;
        font-size: 20rem;
        font-weight: 500;
        color: #ffffff;
        line-height: 28rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .content {
        position: relative;
        width: 318rem;
        height: 140rem;
        font-size: 22rem;
        margin: 0 auto;
        // font-family: PingFang-SC-Bold, PingFang-SC;
        font-weight: bold;
        color: #b05c27;
        line-height: 30rem;
        padding-top: 16rem;
        background-color: #ffffff;
        font-weight: bold;
        text-align: center;

        .content_txt {
          height: 60rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
        .score {
          font-weight: 500;
          color: #b76c3c;
          font-size: 20rem;
          position: absolute;
          bottom: 16rem;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .btn_warp {
      margin-top: 20rem;
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        height: 44rem;
        width: 150rem;
        font-size: 22rem;
        background: #ff654e;
        border-radius: 30px;
        color: #fff;
        text-align: center;
        cursor: pointer;
        line-height: 44rem;
      }
    }
    .time {
      margin-top: 10rem;
      text-align: center;
      font-size: 18rem;
      font-weight: 500;
      color: #b76c3c;
    }
  }
}
</style>